import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserContextService } from './user-context.service';

export const rbacAdminGuard: CanActivateFn = () => {
  const userCtx = inject(UserContextService);
  const router = inject(Router);

  if (userCtx.isAdmin) {
    return true;
  }

  // Non-admin : rediriger vers marques sans exposer d'erreur
  return router.parseUrl('/marques');
};

export const canActivateConfig: CanActivateFn = () => {
  const userCtx = inject(UserContextService);
  const router = inject(Router);
  if (userCtx.canAccessConfig()) return true;
  return router.createUrlTree(['/']);
};
